import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { WorkflowAction, WorkflowInput, WorkflowTrigger } from 'common/src/generated/types';
import * as React from 'react';
import { WorkflowBox } from '../workflowBox';

interface IWorkflowActionStepProps {
    isEdit: boolean;
    workflow: WorkflowInput;
}

export const WorkflowActionStep = (props: IWorkflowActionStepProps) => {
    const { translate } = useHeavent();

    return (
        <WorkflowBox
            category={translate('action_s_lectio_18617')}
            icon="lasso-sparkles"
            title={translate('alors_automatiq_16268')}
        >
            <RichSelect
                isSearchVisible={true}
                name="workflow.action"
                placeholder={translate('choisir_une_act_51814')}
                state={props.isEdit ? 'disabled' : 'active'}
            >
                {props.workflow.trigger === WorkflowTrigger.VolunteersSegment && (
                    <option value={WorkflowAction.SendCampaign}>{translate('SendCampaign')}</option>
                )}

                {props.workflow.trigger === WorkflowTrigger.VolunteersSegment && (
                    <option value={WorkflowAction.SetCustomField}>
                        {translate('SetCustomField')}
                    </option>
                )}

                <option value={WorkflowAction.AddAccreditations}>
                    {translate('AddAccreditations')}
                </option>

                {props.workflow.trigger === WorkflowTrigger.VolunteersSegment && (
                    <option value={WorkflowAction.DeleteAccreditations}>
                        {translate('DeleteAccreditations')}
                    </option>
                )}
            </RichSelect>
        </WorkflowBox>
    );
};
